module.exports = __webpack_public_path__ + "assets/60bfaff89268bf50ddadad42a19e96bf.png";